// Archivo activo/pasivo (Modo Auditor sección B, 2026-09-10) — extraído de
// PatientChartPage.tsx (ronda 2) para reusarlo también en el widget del
// Dashboard (AlertaClasificacionArchivo.tsx), sin duplicarlo dentro del
// mismo paquete. Mismo criterio que `EXT_ARCHIVO_ESTADO` en
// retention-sweep.ts (server, no importable entre paquetes) — esa sí sigue
// duplicada a mano, igual que SISTEMA_SUBTIPO_CONSENTIMIENTO.
import type { Patient } from '@medplum/fhirtypes';

export const EXT_ARCHIVO_ESTADO = 'http://logiacare.ec/fhir/archivo-estado';

export function estadoArchivoDe(patient: Patient): 'activo' | 'pasivo' | undefined {
  const ext = (patient.extension ?? []).find((e) => e.url === EXT_ARCHIVO_ESTADO);
  const estadoExt = ext?.extension?.find((e) => e.url === 'estado');
  return estadoExt?.valueCode === 'activo' || estadoExt?.valueCode === 'pasivo' ? estadoExt.valueCode : undefined;
}
